// extracted by mini-css-extract-plugin
module.exports = {"application-requirements-name":"fpbNd37kkMKJBbD3YNHYn","deadline-warning":"_2CBZ-s_mUXO7HJYa7ALgUB"};